<template src="./roomInventoryDetailSummary.template.html"></template>
<style>
  .quantity::-webkit-inner-spin-button,
  .quantity::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>
<script>
  import moment from "moment-timezone";
  import foliomodal from "../../reservations/reservationDetailVue/folioRecalculateConfirmationModal.vue";
  export default {
    name: "roomInventoryDetailSummary",
    props: ["closeOutDetailObj", "tapChartCallback", "hideDetailSummary", "updateSchedulerConfig"],
    components: {
      foliomodal
    },
    data() {
      return {
        showUnitList: false,
        showRatePlanList: false,
        showUnitTypeList: false,
        RatePlanId: null,
        propertyList: [],
        unitList: [],
        roomInventoryDetails: {
          StartDate: null,
          EndDate: null,
          IsClosed: 0
        },
        isWeekEnd: true,
        weekDays: [
          {
            DayId: 1,
            DayName: "Sun",
            isChecked: 1
          },
          {
            DayId: 2,
            DayName: "Mon",
            isChecked: 1
          },
          {
            DayId: 3,
            DayName: "Tue",
            isChecked: 1
          },
          {
            DayId: 4,
            DayName: "Wed",
            isChecked: 1
          },
          {
            DayId: 5,
            DayName: "Thu",
            isChecked: 1
          },
          {
            DayId: 6,
            DayName: "Fri",
            isChecked: 1
          },
          {
            DayId: 7,
            DayName: "Sat",
            isChecked: 1
          }
        ],
        rateOverrideDetails: {
          propertyId: -1,
          unitId: -1,
          startDate: null,
          endDate: null,
          weekdayBaseRate: null,
          weekdayRatePerAddAdult: null,
          weekdayRatePerAddChild: null,
          weekendBaseRate: null,
          weekendRatePerAddAdult: null,
          weekendRatePerAddChild: null
        },
        opens: "right",
        showRoomInventory: true,
        CloseOutId: null,
        filterObj: {
          Units: [],
          unitTypes: [],
          rates: [],
        },
        // restrictionsDetail: {
        //   RestrictionTypeId: [],
        //   MinStayValue: null
        // },
        restrictionId: -1,
        filterSearchUnitNameText: null,
        filterSearchRatePlanText: null,
        filterSearchUnitTypeNameText: null,
        selectedFilterColumn: null,
        restrictionTypeMinStay: true,
        MinStayValue: null,
        OversellCount: null,
        restrictionTypes: [
          {
            restrictionId: 1,
            restrictionType: "Minimum Stay",
            isChecked: 1,
            colorClass: "whiteColor",
            showRestriction: false
          },
          {
            restrictionId: 2,
            restrictionType: "No Check-in",
            isChecked: 0,
            colorClass: "whiteColor",
            showRestriction: true
          },
          {
            restrictionId: 3,
            restrictionType: "No Check-out",
            isChecked: 0,
            colorClass: "whiteColor",
            showRestriction: true
          },
          {
            restrictionId: 4,
            restrictionType: "OverSell Count",
            isChecked: 1,
            colorClass: "whiteColor",
            showRestriction: false
          }
        ],
        BaseRateRange: null,
        BaseRateRangeColor: "whiteColor",
        MinstayRange: null,
        beforeValue: null,
        afterValue: null,
        minStayColor: "whiteColor",
        AdditionalAdultRange: null,
        AdditionalAdultRangeColor: "whiteColor",
        AdditionalChildRange: null,
        AdditionalChildRangeColor: "whiteColor",
        availabilityColor: null,
        changeInInventory: false,
        changeInRestriction: false,
        changeInRates: false,
        isModalVisible: false,
        modalParams: {},
        BaseRateRangeWK: null,
        BaseRateRangeWKColor: "whiteColor",
        AdditionalAdultRangeWK: null,
        AdditionalAdultRangeWKColor: "whiteColor",
        AdditionalChildRangeWK: null,
        AdditionalChildRangeWKColor: "whiteColor",
        isHostMode: 1,
        unitTypeList: [],
        blockunits: false,
        ratePlanList: [],
        ClearOverride: false,
         restrictionsobj: [],
      restrictionsList: [],
      restrictionCheckin: false,
      restrictionCheckout: false,
      restrictionMinstay: false,
        //   isSummaryLoading: false,
        OversellRange: null,
        OversellColor: "whiteColor",
        oversell_beforeValue: null,
        oversell_afterValue: null,
        unitTypeList_res: null
      };
    },
    methods: {
      getRatePlanDetailList(SearchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_RatePlanList",
          params: {
            StatusId: 1,
            SearchText: SearchText
          },
          callback: function (err, response) {
            if (err) {
              console.log("Get_RatePlanList==>", err);
              return;
            }
            if (response) {
              console.log("Get_RatePlanList==>", response);
              // vm.ratePlanList = response[1];
              let List = response[1];
              for (var i = 0; i < vm.filterObj.rates.length; i++) {
                console.log(
                  "vm.filterObj.rates[i].RatePlanId",
                  vm.filterObj.rates[i].RatePlanId
                );
                let index = List.findIndex(
                  x => x.RatePlanId == vm.filterObj.rates[i].RatePlanId
                );
                if (index > -1) List.splice(index, 1);
                console.log("index", index);
              }
              vm.ratePlanList.splice(0, vm.ratePlanList.length, ...List);
            }
          }
        });
      },
      Get_UnitsAssociated_ToUnitType() {
        let vm = this;
        //
        // filterObj.unitTypes
        console.log("filterObj.unitTypes", vm.filterObj.unitTypes);
        let resultObj = vm.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_UnitsAssociated_ToUnitType",
          params: {
            ModuleAction: "Get_UnitsAssociated_ToUnitType",
            unitTypeId: resultObj.toString()
          },
          callback: function (err, response) {
            if (err) {
              console.log("error in Get_UnitsAssociated_ToUnitType", err);
            }
            if (response) {
              console.log("response of Get_UnitsAssociated_ToUnitType", response);
              vm.unitList = [];
              if (response[0] && response[0].length > 0) {
                vm.unitList = response[0];
                let List = response[0];
                for (var i = 0; i < vm.filterObj.Units.length; i++) {
                  console.log(
                    "vm.filterObj.Units[i].UnitId",
                    vm.filterObj.Units[i].UnitId
                  );
                  let index = List.findIndex(
                    x => x.UnitId == vm.filterObj.Units[i].UnitId
                  );
                  if (index > -1) List.splice(index, 1);
                  console.log("index", index);
                }
                vm.unitList.splice(0, vm.unitList.length, ...List);
              }
            }
          }
        });
      },
      closePopup() {
        let vm = this;
        vm.isModalVisible = false;
      },
      changeRetriction() {
        let vm = this;
        vm.changeInRestriction = true;
        for (let restriction of vm.restrictionTypes) {
          restriction.colorClass = "yellowColor";
        }
      },
      changeMinStayValue() {
        let vm = this;
        vm.minStayColor = "yellowColor";
        vm.changeInRestriction = true;
      },
      changeOversellCount() {
        let vm = this;
        vm.OversellColor = "yellowColor";
        vm.changeInRestriction = true;
      },
      changeBaseRates() {
        let vm = this;
        vm.BaseRateRangeColor = "yellowColor";
        vm.changeInRates = true;
      },
      ClearOverRideRate() {
        let vm = this;
        vm.changeInRates = true;
      },
      changeAdultRates() {
        let vm = this;
        vm.AdditionalAdultRangeColor = "yellowColor";
        vm.changeInRates = true;
      },
      changeChildRates() {
        let vm = this;
        vm.AdditionalChildRangeColor = "yellowColor";
        vm.changeInRates = true;
      },
      changeBaseWkRates() {
        let vm = this;
        vm.BaseRateRangeWKColor = "yellowColor";
        vm.changeInRates = true;
      },
      changeAdultWkRates() {
        let vm = this;
        vm.AdditionalAdultRangeWKColor = "yellowColor";
        vm.changeInRates = true;
      },
      changeChildWkRates() {
        let vm = this;
        vm.AdditionalChildRangeWKColor = "yellowColor";
        vm.changeInRates = true;
      },
      changeAvalibilityColor() {
        let vm = this;
        vm.availabilityColor = "yellowColor";
        vm.changeInInventory = true;
      },
      minusMinStay() {
        let vm = this;

        if(vm.MinStayValue == null && vm.MinstayRange != '' && vm.MinstayRange != null){
          vm.MinStayValue = vm.beforeValue
        }
        else if(vm.MinStayValue == null && (vm.MinstayRange == '' || vm.MinstayRange == null)) {
          vm.MinStayValue = 2;
        }
        if (vm.MinStayValue > 1) {
          vm.MinStayValue = parseInt(vm.MinStayValue) - 1;
        }
        vm.minStayColor = "yellowColor";
        vm.changeInRestriction = true;
      },
      plusMinStay() {
        let vm = this;
        if(vm.MinStayValue == null && vm.MinstayRange != '' && vm.MinstayRange != null){
          vm.MinStayValue = vm.afterValue
        }
        else if (vm.MinStayValue == null && (vm.MinstayRange == '' || vm.MinstayRange == null)) {
          vm.MinStayValue = 1;
        }
        vm.MinStayValue = parseInt(vm.MinStayValue) + 1;
        vm.minStayColor = "yellowColor";
        vm.changeInRestriction = true;
      },
      minusOversell() {
        let vm = this;
        
        if(vm.OversellCount == null && vm.OversellRange != '' && vm.OversellRange != null){
          vm.OversellCount = vm.oversell_beforeValue
        }
        else if(vm.OversellCount == null && (vm.OversellRange == '' || vm.OversellRange == null)) {
          vm.OversellCount = 2;
        }
        if (vm.OversellCount > 1) {
          vm.OversellCount = parseInt(vm.OversellCount) - 1;
        }
        vm.OversellColor = "yellowColor";
        vm.changeInRestriction = true;
      },
      // plusOversell() {
      //   let vm = this;
      //   if(vm.OversellCount == null && vm.OversellRange != '' && vm.OversellRange != null){
      //     vm.OversellCount = vm.oversell_afterValue;
      //   }
      //   else if (vm.OversellCount == null && (vm.OversellRange == '' || vm.OversellRange == null)) {
      //     vm.OversellCount = 1;
      //   }
      //   vm.OversellCount = parseInt(vm.OversellCount) + 1;
      //   vm.OversellColor = "yellowColor";
      //   vm.changeInRestriction = true;
      // },
      plusOversell() {
          let vm = this;
          if (vm.OversellCount == null && vm.OversellRange != '' && vm.OversellRange != null) {
              vm.OversellCount = vm.oversell_afterValue || 0;  // Initialize to oversell_afterValue or 0
          } else if (vm.OversellCount == null && (vm.OversellRange == '' || vm.OversellRange == null)) {
              vm.OversellCount = 0;  // Set to 0 if null
          }
          vm.OversellCount = parseInt(vm.OversellCount) + 1;           
          vm.OversellColor = "yellowColor"; 
          vm.changeInRestriction = true;  
      },

      showMinStayFeild(resctId, resct) {
        if (resctId == 1 && (resct.isChecked == 1 || resct.isChecked == "1")) {
          this.restrictionTypeMinStay = true;
        } else if (
          resctId == 1 &&
          (resct.isChecked == 0 || resct.isChecked == "0")
        ) {
          this.restrictionTypeMinStay = false;
        }
        resct["colorClass"] = "yellowColor";
        this.changeInRestriction = true;
      },
      // clearRestrictionType() {
      //   let vm = this;
      //   vm.restrictionsDetail.RestrictionTypeId = [];
      //   vm.restrictionsDetail.MinStayValue = null;
      // },
      save() {
        let vm = this;
        if (vm.isHostMode == 1 && vm.filterObj.Units.length == 0) {
          vm.isModalVisible = true;
          vm.modalParams = {
            popupTitle: "Save changes to all units",
            popupMessage: "Save changes to all units ?",
            yesButtontext: "Yes",
            noButtonText: "No",
            yesButtonCallback: vm.callForSave,
            noButtonCallback: vm.closePopup
          };
        } else if (vm.isHostMode != 1&& vm.filterObj.unitTypes.length == 0) {
          vm.isModalVisible = true;
          vm.modalParams = {
            popupTitle: "Save changes to all unit types",
            popupMessage: "Save changes to all unit types ?",
            yesButtontext: "Yes",
            noButtonText: "No",
            yesButtonCallback: vm.callForSave,
            noButtonCallback: vm.closePopup
          };
        } else {
          vm.isModalVisible = false;
          vm.callForSave();
        }
      },
      callForSave() {
        let vm = this;
        if(document.getElementById('container')) {
          document.getElementById('container').innerHTML = "<h5>Beta Calendar</h5>";
          vm.updateSchedulerConfig();
        }
        vm.isModalVisible = false;
        if (
          vm.roomInventoryDetails.StartDate == null ||
          vm.roomInventoryDetails.StartDate == "" ||
          (vm.roomInventoryDetails.EndDate == null ||
            vm.roomInventoryDetails.EndDate == "")
        ) {
          vm.$store.dispatch("toastr", {
            type: "warning",
            header: "Warning!",
            message: "Please Select Start and End Dates"
          });
          return;
        }
        // if (vm.filterObj.Units.length == 0) {
        //   vm.$store.dispatch("toastr", {
        //     type: "warning",
        //     header: "Warning!",
        //     message: "Please Select Unit"
        //   });
        //   return;
        // }
        if (vm.changeInInventory) {
          console.log("call for inventory")
          vm.saveroomInventoryDetails();
          // vm.changeInInventory = false;
        }
        if (vm.changeInRestriction) {
          console.log("call for restrictions")
          // let restrictionTypesList = vm.restrictionTypes.filter(
          //   col => col.isChecked == 1
          // );
          // if (restrictionTypesList.length > 0) {
          vm.saveRestrictionDetails();
          // vm.changeInRestriction = false;
          // }
        }
        if (vm.changeInRates && (vm.RatePlanId != '' && vm.RatePlanId != null)) {
          // console.log("here111111111")
          if (
            (vm.rateOverrideDetails.weekdayBaseRate != null &&
              vm.rateOverrideDetails.weekdayBaseRate != "") ||
            (vm.rateOverrideDetails.weekdayRatePerAddAdult != null &&
              vm.rateOverrideDetails.weekdayRatePerAddAdult != "") ||
            (vm.rateOverrideDetails.weekdayRatePerAddChild != null &&
              vm.rateOverrideDetails.weekdayRatePerAddChild != "") ||
            (vm.rateOverrideDetails.weekendBaseRate != null &&
              vm.rateOverrideDetails.weekendBaseRate != "") ||
            (vm.rateOverrideDetails.weekendRatePerAddAdult != null &&
              vm.rateOverrideDetails.weekendRatePerAddAdult != "") ||
            (vm.rateOverrideDetails.weekendRatePerAddChild != null &&
              vm.rateOverrideDetails.weekendRatePerAddChild != "") ||
            (vm.RatePlanId != null && vm.RatePlanId != "")
          ) {
            console.log("call for rates")
            vm.saveRateOverrideDetails();
            // vm.changeInRates = false;
          } else if (!vm.changeInRestriction && !vm.changeInInventory) {
            vm.$store.dispatch("toastr", {
              type: "warning",
              header: "Warning!",
              message: "Please enter rates"
            });
            return;
          }
        }
        // BaseRate: scope.rateOverrideDetails.weekdayBaseRate,
        //     AdditionalAdultRate: scope.rateOverrideDetails.weekdayRatePerAddAdult,
        //     AdditionalChildRate: scope.rateOverrideDetails.weekdayRatePerAddChild,
        //     WeekendBaseRate: scope.rateOverrideDetails.weekendBaseRate,
        //     WeekendAdditionalAdultRate: scope.rateOverrideDetails.weekendRatePerAddAdult,
        //     WeekendAdditionalChildRate: scope.rateOverrideDetails.weekendRatePerAddChild
      },
      saveRestrictionDetails() {
        let scope = this;
        // let restrictionTypesList = scope.restrictionTypes.filter(
        //   col => Object.values(col)
        // );
        // let restrictionTypeIds = scope.restrictionTypes.map(
        //   obj => { let resid = obj.restrictionId;
        //            let checkedValue = obj.isChecked
        //            return Object.values({resid,checkedValue})
        // });
        console.log("here in restrictions");
        let units = scope.filterObj.Units.map(obj => obj.UnitId);
        let unitTypes = scope.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        let weekdayResult = scope.weekDays.filter(col => col.isChecked == 1);
        let days = weekdayResult.map(obj => obj.DayId);
        let resctId = 1;
        for (let restriction of scope.restrictionTypes) {
          if (restriction.restrictionId == 1) {
            restriction.colorClass = scope.minStayColor;
          }
          if (restriction.restrictionId == 4 ) {
            restriction.colorClass = scope.OversellColor;
          }
        }
        scope.$store.dispatch("dataRequestHandler", {
          key: "SaveRestrictionDetail_New",
          params: {
            UnitIds: units ? units.toString() : null,
            UnitTypeIds: unitTypes ? unitTypes.toString() : null,
            StartDate: moment(scope.roomInventoryDetails.StartDate).format(
              "YYYY-MM-DD"
            ),
            EndDate: moment(scope.roomInventoryDetails.EndDate).format(
              "YYYY-MM-DD"
            ),
            Days: days,
            RestrictionValue: scope.MinStayValue,
            RestrictionTypeId: scope.restrictionTypes,
            RatePlanId: scope.RatePlanId,
            OversellCount: scope.isHostMode != 1 ? scope.OversellCount : null,


            // RestrictionTypeToggle : resctType.isChecked
          },
          callback: function (err, response) {
            if (response) {
              console.log("SaveRestrictionDetail_New", response);
              if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage &&
                response[0][0].ErrorMessage != " "
              ) {
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: "Error in saving Restriction details"
                });
              } else {
                scope.getUnitTypeList();
                response && response[3] && response[3].forEach(unit => {
                  const matchingUnitType = scope.unitTypeList_res[1].find(unitType => unitType.UnitTypeId === unit.Unitid);
                  if(unit.Toster == "Warning") {
                    scope.$store.dispatch("toastr", {
                      type: "warning",
                      header: "Warning!",
                      // message: `Maxsellable count updated for ${unit.Unitid}`
                      message: `The oversell count exceeds the maximum sellable units for this unit type "${ matchingUnitType ? matchingUnitType.UnitTypeName : unit.Unitid }"`
                    });
                  } 
                  // else if(unit.Toster == "Success") {
                  //   scope.$store.dispatch("toastr", {
                  //     type: "success",
                  //     header: "Success!",
                  //     message: "Restriction saved successfully"
                  //   });
                  // }
                  else if(unit.Toster == "Error") {
                    scope.$store.dispatch("toastr", {
                      type: "error",
                      header: "Error!",
                      message: `Error in saving Restriction details for ${ matchingUnitType ? matchingUnitType.UnitTypeName : unit.Unitid }`
                    });
                  }
                });

                // scope.$store.dispatch("toastr", {
                //   type: "success",
                //   header: "Success!",
                //   message: "Restriction successfully saved"
                // });
                // scope.changeInRestriction = false;
                // if (((scope.changeInRates || (scope.RatePlanId != '' && scope.RatePlanId != null)) && (
                //   (scope.rateOverrideDetails.weekdayBaseRate != null &&
                //     scope.rateOverrideDetails.weekdayBaseRate != "") ||
                //   (scope.rateOverrideDetails.weekdayRatePerAddAdult != null &&
                //     scope.rateOverrideDetails.weekdayRatePerAddAdult != "") ||
                //   (scope.rateOverrideDetails.weekdayRatePerAddChild != null &&
                //     scope.rateOverrideDetails.weekdayRatePerAddChild != "") ||
                //   (scope.rateOverrideDetails.weekendBaseRate != null &&
                //     scope.rateOverrideDetails.weekendBaseRate != "") ||
                //   (scope.rateOverrideDetails.weekendRatePerAddAdult != null &&
                //     scope.rateOverrideDetails.weekendRatePerAddAdult != "") ||
                //   (scope.rateOverrideDetails.weekendRatePerAddChild != null &&
                //     scope.rateOverrideDetails.weekendRatePerAddChild != "") ||
                //   (scope.RatePlanId != null && scope.RatePlanId != "")
                // ))) {
                //   // scope.Get_InvRatesRestrictions();
                // }
                // else
                if (scope.tapChartCallback && scope.changeInRates == false) {
                  // scope.changeInRestriction = false;
                  // scope.changeInInventory = false;
                  console.log("callback from restrictions")
                  // setTimeout(function () {
                    scope.tapChartCallback();
                    scope.Get_InvRatesRestrictions();
                  // }, 600);
                }
                if (scope.tapChartCallback){
                  scope.Get_InvRatesRestrictions('dontRefresh');
                }

                     if (scope.RatePlanId != -99) {
                scope.restrictionsobj = response[2][0];
              } else if (scope.RatePlanId == -99) {
                scope.restrictionsList = response[2];
              }

              if (scope.restrictionsobj && scope.RatePlanId != -99 ) {
                if (scope.restrictionsobj.Nocheckindays != null) {
                  // scope.restrictionCheckin = true;

                  scope.$store.dispatch("toastr", {
                    type: "info",
                    header: "i Information",
                    message:
                      "The more restrictive restriction exists for" + " " 
                        + scope.restrictionsobj.RatePlan_DisplayName + " " + "-" + " " + "No Check-in on" + " "  + scope.restrictionsobj.Nocheckindays + "."
                  });
                }
                // else {
                //   scope.restrictionCheckin = false;
                // }
                if (scope.restrictionsobj.Nocheckoutdays != null) {
                  // scope.restrictionCheckout = true;
                  scope.$store.dispatch("toastr", {
                    type: "info",
                    header:"i Information",
                    message:
                    "The more restrictive restriction exists for" + " " + scope.restrictionsobj.RatePlan_DisplayName  + " " + "-" + " " + "No Check-out on" + " "  + scope.restrictionsobj.Nocheckoutdays + "."
                     
                  });
                }
                //  else {
                //   scope.restrictionCheckout = false;
                // }
               
                  if (scope.MinStayValue < scope.restrictionsobj.Minstay) {
                    scope.$store.dispatch("toastr", {
                      type: "info",
                      header:"i Information",
                      message:
                       "The more restrictive restriction exists for" + " " + scope.restrictionsobj.RatePlan_DisplayName  + " " + "-" + " " + "Min Stay"+ " " + scope.restrictionsobj.Minstay+"N" +"."
                        
                    });

                    // scope.restrictionMinstay = true;
                  }
                  // else {
                  //   scope.restrictionMinstay = false;
                  // }
               
              }

              if (scope.restrictionsList && scope.RatePlanId == -99) {
                // for(let x in restrictionsList)
                for (let x of scope.restrictionsList) {
                  if (scope.MinStayValue < x.Minstay) {
                    scope.$store.dispatch("toastr", {
                      type: "info",
                      header: "i Information" ,
                      message:
                         "The more restrictive restriction exists for" + " " + x.RatePlan_DisplayName  + " " + "-" + " " + "Min Stay" + " " + x.Minstay+"N" +"."
                    });
                  }

                  if (x.Nocheckindays != null) {
                    scope.$store.dispatch("toastr", {
                      type: "info",
                      header: "i Information",
                      message:
                         "The more restrictive restriction exists for" + " "  + x.RatePlan_DisplayName  + " " + "-" + " " + "No Check-in on" + " "  + x.Nocheckindays + "."
                    });
                  }
                    if (x.Nocheckoutdays != null) {
                    scope.$store.dispatch("toastr", {
                      type: "info",
                      header:"i Information",
                      message:
                       "The more restrictive restriction exists for" + " " + x.RatePlan_DisplayName  + " " + "-" + " " +  "No Check-out on" + " "  + x.Nocheckoutdays + "."
                    });
                  }
                }
              }
              }
              // scope.$router.push("/restrictionList");
            } else {
              console.log(err);
            }
          }
        });
      },
      saveRateOverrideDetails() {
        let scope = this;
        let units = scope.filterObj.Units.map(obj => obj.UnitId);
        // let
        console.log("here in rates")
        let unitTypes = scope.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        let weekdayResult = scope.weekDays.filter(col => col.isChecked == 1);
        let days = weekdayResult.map(obj => obj.DayId);
        scope.$store.dispatch("dataRequestHandler", {
          key: "Save_RateOverride_Details_new",
          // params: scope.rateOverrideDetails,
          params: {
            UnitIds: units,
            UnitTypeIds: unitTypes ? unitTypes.toString() : null,
            StartDate: moment(scope.roomInventoryDetails.StartDate).format(
              "YYYY-MM-DD"
            ),
            EndDate: moment(scope.roomInventoryDetails.EndDate).format(
              "YYYY-MM-DD"
            ),
            Days: days,
            IsWeekend: scope.isWeekEnd,
            BaseRate: scope.rateOverrideDetails.weekdayBaseRate,
            AdditionalAdultRate: scope.rateOverrideDetails.weekdayRatePerAddAdult,
            AdditionalChildRate: scope.rateOverrideDetails.weekdayRatePerAddChild,
            WeekendBaseRate: scope.rateOverrideDetails.weekendBaseRate,
            WeekendAdditionalAdultRate:
              scope.rateOverrideDetails.weekendRatePerAddAdult,
            WeekendAdditionalChildRate:
              scope.rateOverrideDetails.weekendRatePerAddChild,
            RatePlanId: scope.RatePlanId,
            ClearOverride: scope.ClearOverride ? 1 : 0
          },
          callback: function (err, response) {
            if (response) {
              if (
                response[0] &&
                response[0][0] &&
                response[0][0].ErrorMessage &&
                response[0][0].ErrorMessage != " "
              ) {
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "Error!",
                  message: "Error in saving Rate override"
                });
              } else {
                console.log("saved rate override details", response);
                // scope.$store.dispatch("toastr", {
                //   type: "success",
                //   header: "Success!",
                //   message: "Rate override details saved successfully"
                // });

                if (scope.tapChartCallback && scope.changeInRates == true) {
                  // scope.changeInRates = false;
                  console.log("callback from rates")
                  setTimeout(function () {
                    scope.tapChartCallback();
                    scope.Get_InvRatesRestrictions();
                  }, 100);
                }
              }
            } else {
              console.log(err);
              scope.$store.dispatch("toastr", {
                type: "error",
                header: "Rate override details Error!",
                message: err.sqlMessage ? err.sqlMessage : err
              });
            }
          }
        });
      },
      // updateRestrictionType(e, val) {
      //   if (e.target.checked) {
      //     if (e.target.value == 1) {
      //       this.restrictionsDetail.RestrictionTypeId.push(val);
      //     }
      //     if (e.target.value == 2) {
      //       this.restrictionsDetail.RestrictionTypeId.push(val);
      //     }
      //     if (e.target.value == 3) {
      //       this.restrictionsDetail.RestrictionTypeId.push(val);
      //     }
      //   } else {
      //     if (e.target.value == 1) {
      //       var RestrictionTypeIdIndex = this.restrictionsDetail.RestrictionTypeId.findIndex(
      //         x => x == e.target.value
      //       );
      //       if (RestrictionTypeIdIndex > -1) {
      //         this.restrictionsDetail.RestrictionTypeId.splice(
      //           RestrictionTypeIdIndex,
      //           1
      //         );
      //       }
      //     }
      //     if (e.target.value == 2) {
      //       var RestrictionTypeIdIndex = this.restrictionsDetail.RestrictionTypeId.findIndex(
      //         x => x == e.target.value
      //       );
      //       if (RestrictionTypeIdIndex > -1) {
      //         this.restrictionsDetail.RestrictionTypeId.splice(
      //           RestrictionTypeIdIndex,
      //           1
      //         );
      //       }
      //     }
      //     if (e.target.value == 3) {
      //       var RestrictionTypeIdIndex = this.restrictionsDetail.RestrictionTypeId.findIndex(
      //         x => x == e.target.value
      //       );
      //       if (RestrictionTypeIdIndex > -1) {
      //         this.restrictionsDetail.RestrictionTypeId.splice(
      //           RestrictionTypeIdIndex,
      //           1
      //         );
      //       }
      //     }
      //   }
      // },
      removeUnitFromFilter(unitObj, event) {
        let vm = this;
        var index = vm.filterObj.Units.indexOf(unitObj);
        if (index > -1) {
          vm.filterObj.Units.splice(index, 1);
        }
        vm.unitList.push(unitObj);
        if (event) event.stopPropagation();
        vm.Get_InvRatesRestrictions('refresh');
      },
      removeRatesFromFilter(ratesObj, event) {
        let vm = this;
        var index = vm.filterObj.rates.indexOf(ratesObj);
        if (index > -1) {
          vm.filterObj.rates.splice(index, 1);
        }
        vm.ratePlanList.push(ratesObj);
        if (event) event.stopPropagation();

      },
      removeUnitTypeFromFilter(unitTypeObj, event) {
        let vm = this;
        var index = vm.filterObj.unitTypes.indexOf(unitTypeObj);
        if (index > -1) {
          vm.filterObj.unitTypes.splice(index, 1);
        }
        vm.unitTypeList.push(unitTypeObj);
        if (event) event.stopPropagation();
        vm.Get_InvRatesRestrictions('refresh');
      },
      getUnitNamesBySearchText(searchText) {
        let vm = this;
        // let resultObj = vm.filterObj.Properties.map(obj => obj.PropertyId);
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetUnitListBySearchText",
          params: {
            searchText: searchText,
            PropertyId: null
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              let List = response.unitList;
              for (var i = 0; i < vm.filterObj.Units.length; i++) {
                console.log(
                  "vm.filterObj.Units[i].UnitId",
                  vm.filterObj.Units[i].UnitId
                );
                let index = List.findIndex(
                  x => x.UnitId == vm.filterObj.Units[i].UnitId
                );
                if (index > -1) List.splice(index, 1);
                console.log("index", index);
              }
              vm.unitList.splice(0, vm.unitList.length, ...List);
            }
          }
        });
      },

      showFilterByType(filterCol) {
        let vm = this;
        setTimeout(function () {
          vm.selectedFilterColumn = filterCol;
          if (filterCol == "unitName") {
            // vm.getUnitNamesBySearchText();
            if (vm.isHostMode == 1) {
              vm.getPropertyUnits();
            } else {
              vm.Get_UnitsAssociated_ToUnitType();
            }
            // vm.Get_UnitsAssociated_ToUnitType();
            // $("#unitNameDropDown").show();
            setTimeout(function () {
              $("#unitNameDropDown").show();
            }, 10);
          }
          if (filterCol == "unitTypeName") {
            vm.getUnitTypeList();
            // $("#unitNameDropDown").show();
            setTimeout(function () {
              $("#unitTypeNameDropDown").show();
            }, 10);
          }
          if (filterCol == "ratePlan") {
            vm.getRatePlanDetailList();
            // $("#unitNameDropDown").show();
            setTimeout(function () {
              $("#ratePlanDropDown").show();
            }, 10);
          }
        }, 10);
      },
      showFilterByUnitType() { },
      showunitList() {
        let vm = this;
        vm.showUnitList = true;
        if (vm.isHostMode == 1) {
          let searchText = "";
          vm.getUnitNamesBySearchText(searchText);
        } else {
          vm.Get_UnitsAssociated_ToUnitType();
        }
      },
      showunitTypeList() {
        this.showUnitTypeList = true;
      },
      addUnitToFilter(unitObj) {
        let vm = this;
        // vm.changeInInventory = false;
        // vm.changeInRestriction = false;
        // vm.changeInRates = false;
        vm.filterObj.Units.push(unitObj);
        vm.filterSearchUnitNameText = null;
        var index = vm.unitList.indexOf(unitObj);

        if (index > -1) {
          vm.unitList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
        vm.Get_InvRatesRestrictions('refresh');
      },
      addRatesToFilter(ratesObj) {
        let vm = this;
        vm.changeInRates = true;
        vm.filterObj.rates.push(ratesObj);
        vm.filterSearchRatePlanText = null;
        var index = vm.ratePlanList.indexOf(ratesObj);
        if (index > -1) {
          vm.ratePlanList.splice(index, 1);
        }
        vm.selectedFilterColumn = null;
        vm.Get_InvRatesRestrictions('refresh');


      },
      addUnitTypeToFilter(unitTypeObj) {
        let vm = this;
        // vm.changeInInventory = false;
        // vm.changeInRestriction = false;
        // vm.changeInRates = false;
        console.log("unitTypeList1", vm.unitTypeList);
        vm.filterObj.unitTypes.push(unitTypeObj);
        vm.filterSearchUnitTypeNameText = null;
        var index = vm.unitTypeList.indexOf(unitTypeObj);

        if (index > -1) {
          vm.unitTypeList.splice(index, 1);
          console.log("unitTypeList2", vm.unitTypeList);
        }
        vm.selectedFilterColumn = null;
        vm.Get_UnitsAssociated_ToUnitType();
        vm.Get_InvRatesRestrictions('refresh');
      },
      Get_CloseOutDetail(closeOutId) {
        let scope = this;
        this.$store.dispatch("dataRequestHandler", {
          key: "Get_CloseOutDetail",
          params: {
            CloseOutId: closeOutId
          },
          callback: function (err, response) {
            if (response) {
              console.log("response==>", response.recordsets[0][0]);
              scope.roomInventoryDetails = response.recordsets[0][0];

              if (scope.roomInventoryDetails.IsClosed == true) {
                scope.roomInventoryDetails.IsClosed = 1;
              } else if (scope.roomInventoryDetails.IsClosed == false) {
                scope.roomInventoryDetails.IsClosed = 0;
              }
            } else {
              console.log(err);
            }
          }
        });
      },
      // updateValues(values) {
      //   this.roomInventoryDetails.StartDate = values.startDate
      //     .toISOString()
      //     .slice(0, 10);
      //   this.roomInventoryDetails.EndDate = values.endDate
      //     .toISOString()
      //     .slice(0, 10);
      // },
      getPropertyMetaData: function () {
        let scope = this;
        this.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (response) {
              scope.propertyList.splice(
                0,
                scope.propertyList.length,
                ...response.propertyList
              );
            } else {
              console.log(err);
            }
          }
        });
      },
      getPropertyUnits() {
        let scope = this;

        this.$store.dispatch("dataRequestHandler", {
          key: "GetUnitList",
          params: {
            PropertyId: scope.roomInventoryDetails.PropertyId,
            StatusId: 1
          },
          callback: function (err, response) {
            if (response) {
              // scope.unitList.splice(
              //   0,
              //   scope.unitList.length,
              //   ...response.recordsets[1]
              // );
              // for (let unit of scope.unitList) {
              //   if (unit.UnitId == scope.roomInventoryDetails.UnitId) {
              //     scope.roomInventoryDetails.UnitId = unit.UnitId;
              //     return;
              //   } else {
              //     scope.roomInventoryDetails.UnitId = null;
              //   }
              // }
            } else {
              console.log(err);
            }
          }
        });
      },

      saveroomInventoryDetails() {
        let scope = this;
        console.log("here in inventory");
        // console.log("filterObj", scope.filterObj.Units);
        // filterObj.Units.map(obj => obj.UnitId);
        let units = scope.filterObj.Units.map(obj => obj.UnitId);
        let unitTypes = scope.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        // let
        let weekdayResult = scope.weekDays.filter(col => col.isChecked == 1);
        let days = weekdayResult.map(obj => obj.DayId);
        console.log("days", days);
        scope.$store.dispatch("dataRequestHandler", {
          key: "Save_InventoryDetails_new",
          // params: scope.roomInventoryDetails,
          params: {
            UnitIds: units.toString(),
            UnitTypeIds: unitTypes ? unitTypes.toString() : null,
            StartDate: moment(scope.roomInventoryDetails.StartDate).format(
              "YYYY-MM-DD"
            ),
            EndDate: moment(scope.roomInventoryDetails.EndDate).format(
              "YYYY-MM-DD"
            ),
            IsBlackOut: scope.roomInventoryDetails.IsClosed,
            Days: days.toString(),
            RatePlanId: scope.RatePlanId

          },
          callback: function (err, response) {
            if (response) {
              // console.log("saved Save_InventoryDetails_new", response);
              if (
                response &&
                response[0][0] &&
                response[0][0].ErrorMessage === " "
              ) {
                // scope.$store.dispatch("toastr", {
                //   type: "success",
                //   header: "Success!",
                //   message: "Unit Inventory details successfully saved"
                // });
                // scope.changeInInventory = false;
                // if (((scope.changeInRates || (scope.RatePlanId != '' && scope.RatePlanId != null)) && (
                //   (scope.rateOverrideDetails.weekdayBaseRate != null &&
                //     scope.rateOverrideDetails.weekdayBaseRate != "") ||
                //   (scope.rateOverrideDetails.weekdayRatePerAddAdult != null &&
                //     scope.rateOverrideDetails.weekdayRatePerAddAdult != "") ||
                //   (scope.rateOverrideDetails.weekdayRatePerAddChild != null &&
                //     scope.rateOverrideDetails.weekdayRatePerAddChild != "") ||
                //   (scope.rateOverrideDetails.weekendBaseRate != null &&
                //     scope.rateOverrideDetails.weekendBaseRate != "") ||
                //   (scope.rateOverrideDetails.weekendRatePerAddAdult != null &&
                //     scope.rateOverrideDetails.weekendRatePerAddAdult != "") ||
                //   (scope.rateOverrideDetails.weekendRatePerAddChild != null &&
                //     scope.rateOverrideDetails.weekendRatePerAddChild != "") ||
                //   (scope.RatePlanId != null && scope.RatePlanId != "")
                // ))) {
                //   // scope.Get_InvRatesRestrictions();
                // }
                // else
                if ((scope.tapChartCallback && scope.changeInRestriction == false && scope.changeInRates == false)) {
                  // scope.changeInInventory = false;
                  console.log("callback from inventory")
                  // setTimeout(function () {
                    scope.tapChartCallback();
                    scope.Get_InvRatesRestrictions();
                  // }, 600);

                }
                if (scope.tapChartCallback){
                  scope.Get_InvRatesRestrictions('dontRefresh');
                }
              } else {
                scope.$store.dispatch("toastr", {
                  type: "error",
                  header: "Unit Inventory details Error!",
                  message: response[0][0].ErrorMessage
                });
              }
            } else {
              console.log(err);
              scope.$store.dispatch("toastr", {
                type: "error",
                header: "Unit Inventory details Error!",
                message: err.sqlMessage ? err.sqlMessage : err
              });
            }
          }
        });
      },
      updateStartDate(key, dateObj) {
        let scope = this;
        scope.roomInventoryDetails.StartDate = dateObj
          ? dateObj.format("DD MMM YYYY")
          : null;
        console.log(
          "scope.roomInventoryDetails.StartDate",
          scope.roomInventoryDetails.StartDate
        );
        scope.Get_InvRatesRestrictions('refresh');
      },
      updateEndDate(key, dateObj) {
        let scope = this;
        scope.roomInventoryDetails.EndDate = dateObj
          ? dateObj.format("DD MMM YYYY")
          : null;
        console.log(
          "scope.roomInventoryDetails.EndDate",
          scope.roomInventoryDetails.EndDate
        );
        scope.Get_InvRatesRestrictions('refresh');
      },
      cancelCloseOutDetails() {
        let scope = this;
        if (scope.hideDetailSummary) {
          scope.hideDetailSummary();
          // scope.
          Object.assign(this.$data, this.$options.data.call(this));
        }
      },
      reset() {
        console.log("reset");
        Object.assign(this.$data, this.$options.data.call(this));
      },
      callToInventory() {
        let vm = this;
        vm.Get_InvRatesRestrictions();
      },
      getUnitTypeList(searchText) {
        let vm = this;
        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_UnitTypeList",
          params: {
            sortBy: null,
            sortOrder: null,
            propertyId: -1,
            statusId: 1,
            searchText: searchText,
            FromSetup: false
          },
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              vm.unitTypeList_res = response;
              console.log("Get_UnitTypeList==>", response);
              if (response[1] && response[1].length > 0) {
                vm.unitTypeList.splice(0, vm.unitTypeList.length, ...response[1]);
              }
              for (var unitType of vm.filterObj.unitTypes) {
                let index = vm.unitTypeList.findIndex(
                  x => x.UnitTypeId == unitType.UnitTypeId
                );
                if (index > -1) {
                  vm.unitTypeList.splice(index, 1);
                }
              }
            }
          }
        });
      },
      clearData() {
        let vm = this;
        vm.filterObj.Units.splice(0);
        vm.filterObj.unitTypes.splice(0);
        vm.showUnitList = false;
        vm.showUnitTypeList = false;
        vm.showRatePlanList = false;
        vm.Get_InvRatesRestrictions();
      },
      Get_InvRatesRestrictions(from) {
        let vm = this;
        console.log("from", from)
        if(from && from == 'refresh'){
          vm.changeInInventory = false;
          vm.changeInRestriction = false;
          vm.changeInRates = false;
        }
        vm.ClearOverride = false;
        let units = vm.filterObj.Units.map(obj => obj.UnitId);
        let unitTypes = vm.filterObj.unitTypes.map(obj => obj.UnitTypeId);
        // let startDate = vm.roomInventoryDetails.StartDate
        //   ? moment(vm.roomInventoryDetails.StartDate).format("YYYY-MM-DD")
        //   : moment()
        //     .add(-7, "days")
        //     .format("YYYY-MM-DD"),
        //   endDate = vm.roomInventoryDetails.EndDate
        //     ? moment(vm.roomInventoryDetails.EndDate).format("YYYY-MM-DD")
        //     : moment(startDate)
        //       .add(90, "days")
        //       .format("YYYY-MM-DD");

        // if (!vm.roomInventoryDetails.StartDate)
        //   vm.roomInventoryDetails.StartDate = moment(startDate).format(
        //     "DD MMM YYYY"
        //   );
        // if (!vm.roomInventoryDetails.EndDate)
        //   vm.roomInventoryDetails.EndDate = moment(endDate).format("DD MMM YYYY");

        vm.$store.dispatch("dataRequestHandler", {
          key: "Get_InvRatesRestrictions",
          // params: scope.roomInventoryDetails,
          params: {
            UnitIds: units ? units.toString() : null,
            UnitTypeIds: unitTypes ? unitTypes.toString() : null,
            StartDate: vm.roomInventoryDetails.StartDate ? moment(vm.roomInventoryDetails.StartDate).format("YYYY-MM-DD") : null,
            EndDate: vm.roomInventoryDetails.EndDate ? moment(vm.roomInventoryDetails.EndDate).format("YYYY-MM-DD") : null,
            IsWeekend: true,
            RatePlanId: vm.RatePlanId
          },
          callback: function (err, response) {
            if (err) {
              console.log(err);
              vm.$store.dispatch("toastr", {
                type: "error",
                header: "Unit Inventory details Error!",
                message: err.sqlMessage ? err.sqlMessage : err
              });
            }
            if (response) {
              console.log("Get_InvRatesRestrictions", response);

              if (response[1] && response[1][0]) {
                vm.isHostMode = response[1][0].IsHostMode;
              }
              vm.MinStayValue = null;
              vm.OversellCount = null;
              vm.rateOverrideDetails.weekdayBaseRate = null;
              vm.rateOverrideDetails.weekdayRatePerAddAdult = null;
              vm.rateOverrideDetails.weekdayRatePerAddChild = null;
              vm.rateOverrideDetails.weekendBaseRate = null;
              vm.rateOverrideDetails.weekendRatePerAddAdult = null;
              vm.rateOverrideDetails.weekendRatePerAddChild = null;
              if (response[0][0].MinstayRange) {
                var [before, after] = response[0][0].MinstayRange.split("-")
                console.log("before, after", before, after);
                vm.beforeValue = before;
                vm.afterValue = after;
                if(!after){
                  vm.afterValue = before;
                }
                vm.MinstayRange = response[0][0].MinstayRange + " night(s)";
              } else {
                vm.MinstayRange = null;
                vm.MinStayValue = 1;
              }
              if (response[0][0].OversellRange) {
                var [oversellBefore, oversellAfter] = response[0][0].OversellRange.split("-")
                console.log("oversellBefore, oversellAfter", oversellBefore, oversellAfter);
                vm.oversell_beforeValue = oversellBefore;
                vm.oversell_afterValue = oversellAfter;
                if(!after){
                  vm.oversell_afterValue = oversellBefore;
                }
                vm.OversellRange = response[0][0].OversellRange;

                // vm.oversell_beforeValue = response[0][0].OversellRange;
                // vm.oversell_afterValue = response[0][0].OversellRange;
                // vm.OversellRange = response[0][0].OversellRange;
              } else {
                vm.OversellRange = null;
                vm.OversellCount = null;
              }
              if (response[0][0].RatesFlag == 0) {
                vm.BaseRateRangeColor = "whiteColor";
                vm.AdditionalAdultRangeColor = "whiteColor";
                vm.AdditionalChildRangeColor = "whiteColor";
                vm.BaseRateRangeWKColor = "whiteColor";
                vm.AdditionalAdultRangeWKColor = "whiteColor";
                vm.AdditionalChildRangeWKColor = "whiteColor";
              } else if (response[0][0].RatesFlag == 1) {
                vm.BaseRateRangeColor = "blueColor";
                vm.AdditionalAdultRangeColor = "blueColor";
                vm.AdditionalChildRangeColor = "blueColor";
                vm.BaseRateRangeWKColor = "blueColor";
                vm.AdditionalAdultRangeWKColor = "blueColor";
                vm.AdditionalChildRangeWKColor = "blueColor";
              } else if (response[0][0].RatesFlag == 2) {
                vm.BaseRateRangeColor = "greyColor";
                vm.AdditionalAdultRangeColor = "greyColor";
                vm.AdditionalChildRangeColor = "greyColor";
                vm.BaseRateRangeWKColor = "greyColor";
                vm.AdditionalAdultRangeWKColor = "greyColor";
                vm.AdditionalChildRangeWKColor = "greyColor";
              }
              vm.BaseRateRange = response[0][0].BaseRateRange;
              vm.AdditionalAdultRange = response[0][0].AdditionalAdultRange;
              vm.AdditionalChildRange = response[0][0].AdditionalChildRange;

              vm.BaseRateRangeWK = response[0][0].BaseRateRangeWK;
              vm.AdditionalAdultRangeWK = response[0][0].AdditionalAdultRangeWK;
              vm.AdditionalChildRangeWK = response[0][0].AdditionalChildRangeWK;

              if (vm.BaseRateRangeWK) {
                vm.isWeekEnd = 1;
              } else {
                vm.isWeekEnd = 0;
              }

              if (response[0][0].AvailabilityFlag == 1) {
                vm.roomInventoryDetails.IsClosed = 1;
                vm.availabilityColor = "blueColor";
              } else if (response[0][0].AvailabilityFlag == 0) {
                vm.roomInventoryDetails.IsClosed = 0;
                vm.availabilityColor = "blueColor";
              } else if (response[0][0].AvailabilityFlag == 2) {
                vm.roomInventoryDetails.IsClosed = 0;
                vm.availabilityColor = "greyColor";
              }
              if (response[0][0].MinstayFlag == 1) {
                vm.minStayColor = "blueColor";
                function MinstayFlag1(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "blueColor";
                    }
                  }
                }
                MinstayFlag1(vm.restrictionTypes, "restrictionId", 1);
              } else if (response[0][0].MinstayFlag == 2) {
                vm.minStayColor = "greyColor";
                function MinstayFlag2(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "greyColor";
                    }
                  }
                }
                MinstayFlag2(vm.restrictionTypes, "restrictionId", 1);
              } else if (response[0][0].MinstayFlag == 0) {
                vm.minStayColor = "whiteColor";
                function MinstayFlag0(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "whiteColor";
                    }
                  }
                }
                MinstayFlag0(vm.restrictionTypes, "restrictionId", 1);
              }
              if (response[0][0].NocheckinFlag == 1) {
                function NocheckinFlag1(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 1;
                      data[i]["colorClass"] = "blueColor";
                    }
                  }
                }
                NocheckinFlag1(vm.restrictionTypes, "restrictionId", 2);
              } else if (response[0][0].NocheckinFlag == 2) {
                function NocheckinFlag2(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 0;
                      data[i]["colorClass"] = "greyColor";
                    }
                  }
                }
                NocheckinFlag2(vm.restrictionTypes, "restrictionId", 2);
              } else if (response[0][0].NocheckinFlag == 0) {
                function NocheckinFlag0(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 0;
                      data[i]["colorClass"] = "whiteColor";
                    }
                  }
                }
                NocheckinFlag0(vm.restrictionTypes, "restrictionId", 2);
              }
              if (response[0][0].NocheckoutFlag == 1) {
                function NocheckoutFlag1(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 1;
                      data[i]["colorClass"] = "blueColor";
                    }
                  }
                }
                NocheckoutFlag1(vm.restrictionTypes, "restrictionId", 3);
              } else if (response[0][0].NocheckoutFlag == 2) {
                function NocheckoutFlag2(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 0;
                      data[i]["colorClass"] = "greyColor";
                    }
                  }
                }
                NocheckoutFlag2(vm.restrictionTypes, "restrictionId", 3);
              } else if (response[0][0].NocheckoutFlag == 0) {
                function NocheckoutFlag0(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      data[i]["isChecked"] = 0;
                      data[i]["colorClass"] = "whiteColor";
                    }
                  }
                }
                NocheckoutFlag0(vm.restrictionTypes, "restrictionId", 3);
              }
              // ====

              if (response[0][0].MinstayFlag == 1) {
                vm.OversellColor = "blueColor";
                function MinstayFlag1(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "blueColor";
                    }
                  }
                }
                MinstayFlag1(vm.restrictionTypes, "restrictionId", 4);
              } else if (response[0][0].MinstayFlag == 2) {
                vm.OversellColor = "greyColor";
                function MinstayFlag2(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "greyColor";
                    }
                  }
                }
                MinstayFlag2(vm.restrictionTypes, "restrictionId", 4);
              } else if (response[0][0].MinstayFlag == 0) {
                vm.OversellColor = "whiteColor";
                function MinstayFlag0(data, property, value) {
                  for (var i = 0, l = data.length; i < l; i++) {
                    if (data[i][property] === value) {
                      vm.restrictionTypeMinStay = true;
                      data[i]["colorClass"] = "whiteColor";
                    }
                  }
                }
                MinstayFlag0(vm.restrictionTypes, "restrictionId", 4);
              }

              // ====
              // vm.$store.dispatch("toastr", {
              //   type: "success",
              //   header: "Success",
              //   message: "Unit Inventory details rendered successfully"
              // });
              if(!from || from != 'refresh'){
                setTimeout(function () {
                vm.changeInInventory = false;
                vm.changeInRestriction = false;
                vm.changeInRates = false;
              }, 15000);
              }
              

              // vm.getRatePlanDetailList();
              // if(vm.changeInInventory || vm.changeInRestriction || vm.changeInRates){
              //   if (vm.tapChartCallback) {
              //     vm.tapChartCallback();
              //   }
              // }
            }
          }
        });
      }
    },
    computed: {
      showClearOverRideToggel() {
        let vm = this;
        let ratePlan = vm.ratePlanList.filter(rateplan => { if (rateplan.RatePlanId == vm.RatePlanId) { return rateplan } })
        return ratePlan && ratePlan[0] && ratePlan[0].IsDerived ? ratePlan[0].IsDerived : false;
      }
    },
    created() {
      let vm = this;
      vm.$store.state.bus.$on("setInvPannelValues", function (selected) {
        console.log("selected", selected);
        vm.getRatePlanDetailList();
        vm.roomInventoryDetails.StartDate = moment(selected.filterObj.startDate).format("DD MMM YYYY");
        vm.roomInventoryDetails.EndDate = moment(selected.filterObj.endDate).format("DD MMM YYYY");
        vm.RatePlanId = selected.ratePlanId;
      });
      vm.getRatePlanDetailList();
      // vm.$store.state.bus.$on("reset", function () {
      //   // vm.reset();
      //   vm.filterObj.Units.splice(0);
      //   vm.filterObj.unitTypes.splice(0);
      //   vm.weekDays = vm.weekDays.filter(col => col.isChecked = 1);
      //   vm.Get_InvRatesRestrictions('refresh');
      //   vm.getRatePlanDetailList();
      // });

    },
    watch: {
      filterSearchUnitNameText(searchText) {
        // if (searchText) {
        this.getUnitNamesBySearchText(searchText);
        // }
      },
      filterSearchRatePlanText(searchText) {
        this.getRatePlanDetailList(searchText)
      },
      filterSearchUnitTypeNameText(searchText) {
        this.getUnitTypeList(searchText);
      },
      closeOutDetailObj: {
        handler: function (resObj, oldVal) {
          if (resObj) {
            this.CloseOutId = resObj.closeOutId;
            this.Get_CloseOutDetail(resObj.closeOutId);
          }
        },
        deep: true
      },
      $route: "Get_CloseOutDetail",
      "roomInventoryDetails.PropertyId": function (newVal) {
        console.log(newVal);
        if (newVal) this.getPropertyUnits();
      }
    },

    mounted() {
      let vm = this;
      vm.reset();
      vm.$store.state.bus.$on("setInvPannelValues", function (selected) {
        console.log("selected", selected);
        vm.roomInventoryDetails.StartDate = moment(selected.filterObj.startDate).format("DD MMM YYYY");
        vm.roomInventoryDetails.EndDate = moment(selected.filterObj.endDate).format("DD MMM YYYY");
        vm.RatePlanId = selected.ratePlanId;
      });

      console.log("Unit Inventory module loaded");
      vm.getPropertyMetaData();
      vm.getPropertyUnits();
      $(document).click(function (e) {
        $(".form-control.searchResultsAmenities").hide();
        vm.selectedFilterColumn = null;
      });

      $(document).click(function (e) {
        setTimeout(function () {
          $("#unitNameDropDown").hide();
        }, 10);
      });
      vm.Get_InvRatesRestrictions('refresh');
      vm.getRatePlanDetailList();

    }
  };
</script>